export default __webpack_public_path__ + "img/0d90425a29e6c3c45383cb00f70de697.svg";